import * as React from 'react';
import type { HTMLAttributes } from 'react';

import { cn } from '../utils/cn';

export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />
));

Skeleton.displayName = 'Skeleton';
